<template>
    <div class="-m-5 md:m-0 h-full flex-1 overflow-hidden">
        <tabulator
            :columns="columns"
            :actions="actions"
            :refresh.sync="refreshTable"
            :loading="tableIsLoading"
            :loading-text="tableLoadingText"
            ajax-path="whmcs/clients"
        />
        <app-modal
            :show.sync="showAddClientModal"
            width="lg:w-1/3"
        >
            <template slot="header">Add Client</template>
            <template slot="body">
                <div class="flex">
                    <app-input
                        v-model="addClientForm.firstname"
                        placeholder="First Name"
                        :error="addClientForm.errors.get('firstname')"
                        @updated="addClientForm.errors.clear('firstname')"
                        focus
                        required
                        class="flex-1 mr-4"
                    />
                    <app-input
                        v-model="addClientForm.lastname"
                        placeholder="Last Name"
                        :error="addClientForm.errors.get('lastname')"
                        @updated="addClientForm.errors.clear('lastname')"
                        required
                        class="flex-1"
                    />
                </div>
                <div class="flex">
                    <app-input
                        v-model="addClientForm.companyname"
                        placeholder="Company Name"
                        :error="addClientForm.errors.get('companyname')"
                        @updated="addClientForm.errors.clear('companyname')"
                        class="flex-1 mr-4"
                    />
                    <app-input
                        v-model="addClientForm.email"
                        placeholder="Email"
                        :error="addClientForm.errors.get('email')"
                        @updated="addClientForm.errors.clear('email')"
                        required
                        class="flex-1"
                    />
                </div>
                <div class="flex">
                    <app-input
                        v-model="addClientForm.address1"
                        placeholder="Address 1"
                        :error="addClientForm.errors.get('address1')"
                        @updated="addClientForm.errors.clear('address1')"
                        required
                        class="flex-1 mr-4"
                    />
                    <app-input
                        v-model="addClientForm.address2"
                        placeholder="Address 2"
                        :error="addClientForm.errors.get('address2')"
                        @updated="addClientForm.errors.clear('address2')"
                        class="flex-1"
                    />
                </div>
                <div class="flex">
                    <app-input
                        v-model="addClientForm.city"
                        placeholder="City"
                        :error="addClientForm.errors.get('city')"
                        @updated="addClientForm.errors.clear('city')"
                        required
                        class="flex-1 mr-4"
                    />
                    <app-input
                        v-model="addClientForm.state"
                        placeholder="State"
                        :error="addClientForm.errors.get('state')"
                        @updated="addClientForm.errors.clear('state')"
                        required
                        class="flex-1"
                    />
                </div>
                <div class="flex">
                    <app-select
                        v-model="addClientForm.country"
                        placeholder="Country"
                        :error="addClientForm.errors.get('country')"
                        @updated="addClientForm.errors.clear('country')"
                        :options="countries"
                        label-key="countryName"
                        value-key="countryShortCode"
                        required
                        class="flex-1 mr-4"
                    />
                    <app-input
                        v-model="addClientForm.postcode"
                        placeholder="Postal Code"
                        :error="addClientForm.errors.get('postcode')"
                        @updated="addClientForm.errors.clear('postcode')"
                        required
                        class="flex-1 mb-5"
                    />
                </div>
                <div class="flex">
                    <app-input
                        v-model="addClientForm.phonenumber"
                        placeholder="Phone Number"
                        :error="addClientForm.errors.get('phonenumber')"
                        @updated="addClientForm.errors.clear('phonenumber')"
                        required
                        class="flex-1 mr-4"
                    />
                    <app-input
                        type="password"
                        v-model="addClientForm.password2"
                        placeholder="Password"
                        :error="addClientForm.errors.get('password2')"
                        @updated="addClientForm.errors.clear('password2')"
                        class="flex-1"
                    />
                </div>
                <div class="mt-5 flex items-center justify-end">
                    <app-button 
                        class="btn-white" 
                        @click="showAddClientModal = false"
                        :disable="addClientFormIsLoading"
                    >Cancel</app-button>
                    <app-button 
                        class="btn-blue ml-3" 
                        @click="store"
                        :loading="addClientFormIsLoading"
                    >Add</app-button>
                </div>
            </template>
        </app-modal>
        <app-modal
            :show.sync="showEditClientModal"
            width="lg:w-1/3"
        >
            <template slot="header">Edit Client</template>
            <template slot="body">
                <div class="flex">
                    <app-input
                        v-model="editClientForm.firstname"
                        placeholder="First Name"
                        :error="editClientForm.errors.get('firstname')"
                        @updated="editClientForm.errors.clear('firstname')"
                        focus
                        required
                        class="flex-1 mr-4"
                    />
                    <app-input
                        v-model="editClientForm.lastname"
                        placeholder="Last Name"
                        :error="editClientForm.errors.get('lastname')"
                        @updated="editClientForm.errors.clear('lastname')"
                        required
                        class="flex-1"
                    />
                </div>
                <div class="flex">
                    <app-input
                        v-model="editClientForm.companyname"
                        placeholder="Company Name"
                        :error="editClientForm.errors.get('companyname')"
                        @updated="editClientForm.errors.clear('companyname')"
                        class="flex-1 mr-4"
                    />
                    <app-input
                        v-model="editClientForm.email"
                        placeholder="Email"
                        :error="editClientForm.errors.get('email')"
                        @updated="editClientForm.errors.clear('email')"
                        required
                        class="flex-1"
                    />
                </div>
                <div class="flex">
                    <app-input
                        v-model="editClientForm.address1"
                        placeholder="Address 1"
                        :error="editClientForm.errors.get('address1')"
                        @updated="editClientForm.errors.clear('address1')"
                        required
                        class="flex-1 mr-4"
                    />
                    <app-input
                        v-model="editClientForm.address2"
                        placeholder="Address 2"
                        :error="editClientForm.errors.get('address2')"
                        @updated="editClientForm.errors.clear('address2')"
                        class="flex-1"
                    />
                </div>
                <div class="flex">
                    <app-input
                        v-model="editClientForm.city"
                        placeholder="City"
                        :error="editClientForm.errors.get('city')"
                        @updated="editClientForm.errors.clear('city')"
                        required
                        class="flex-1 mr-4"
                    />
                    <app-input
                        v-model="editClientForm.state"
                        placeholder="State"
                        :error="editClientForm.errors.get('state')"
                        @updated="editClientForm.errors.clear('state')"
                        required
                        class="flex-1"
                    />
                </div>
                <div class="flex">
                    <app-select
                        v-model="editClientForm.country"
                        placeholder="Country"
                        :error="editClientForm.errors.get('country')"
                        @updated="editClientForm.errors.clear('country')"
                        :options="countries"
                        label-key="countryName"
                        value-key="countryShortCode"
                        required
                        class="flex-1 mr-4"
                    />
                    <app-input
                        v-model="editClientForm.postcode"
                        placeholder="Postal Code"
                        :error="editClientForm.errors.get('postcode')"
                        @updated="editClientForm.errors.clear('postcode')"
                        required
                        class="flex-1 mb-5"
                    />
                </div>
                <div class="flex">
                    <app-input
                        v-model="editClientForm.phonenumber"
                        placeholder="Phone Number"
                        :error="editClientForm.errors.get('phonenumber')"
                        @updated="editClientForm.errors.clear('phonenumber')"
                        required
                        class="flex-1 mr-4"
                    />
                    <app-input
                        type="password"
                        v-model="editClientForm.password2"
                        placeholder="Password"
                        :error="editClientForm.errors.get('password2')"
                        @updated="editClientForm.errors.clear('password2')"
                        class="flex-1"
                    />
                </div>
                <div class="mt-5 flex items-center justify-end">
                    <app-button 
                        class="btn-white" 
                        @click="showEditClientModal = false"
                        :disable="editClientFormIsLoading"
                    >Cancel</app-button>
                    <app-button 
                        class="btn-blue ml-3" 
                        @click="update"
                        :loading="editClientFormIsLoading"
                    >Update</app-button>
                </div>
            </template>
        </app-modal>
    </div>
</template>

<script>
    import Form from '@/helpers/Form';
    import Http from '@/helpers/Http';
    import countries from '@/countries.js';

    export default {
        data() {
            return {
                countries,
                selected: {},
                refreshTable: false,
                tableIsLoading: false,
                tableLoadingText: null,
                showAddClientModal: false,
                showEditClientModal: false,
                addClientFormIsLoading: false,
                editClientFormIsLoading: false,
                addClientForm: new Form({
                    firstname: null,
                    lastname: null,
                    companyname: null,
                    email: null,
                    address1: null,
                    address2: null,
                    city: null,
                    state: null,
                    postcode: null,
                    country: 'AU',
                    phonenumber: null,
                    password2: null,
                }),
                editClientForm: new Form({
                    firstname: null,
                    lastname: null,
                    companyname: null,
                    email: null,
                    address1: null,
                    address2: null,
                    city: null,
                    state: null,
                    postcode: null,
                    country: 'AU',
                    phonenumber: null,
                    password2: null,
                }),
                columns: [
                    {
                        title: 'Name',
                        field: 'name',
                        sorter: 'string',
                        minWidth: 150,
                    },
                    {
                        title: 'Company',
                        field: 'companyname',
                        sorter: 'string',
                        minWidth: 200,
                        formatter({_cell}) {
                            if (_cell.value) {
                                return _cell.value;
                            }

                            return '--';
                        }
                    },
                    {
                        title: 'Email',
                        field: 'email',
                        sorter: 'string',
                        minWidth: 300,
                    },
                    {
                        title: 'Status',
                        field: 'status',
                        sorter: 'string',
                        minWidth: 100,
                        formatter({_cell}) {
                            if (_cell.value === 'Inactive') {
                                return `<span class='badge badge-red'>Inactive</span>`;
                            }

                            return `<span class='badge badge-green'>Active</span>`;
                        }
                    }
                ],
                actions: [
                    {
                        label: 'Add',
                        icon: () => import('@/icons/Add.vue'),
                        handler: () => {
                            this.showAddClientModal = true;
                            this.addClientForm.errors.clear();
                            this.addClientForm.reset();
                        }
                    },
                    {
                        label: 'Edit',
                        icon: () => import('@/icons/EditOutlined.vue'),
                        handler: (data) => {
                            this.selected = data[0];
                            this.showEditClientModal = true;
                            this.editClientForm.set(data[0]);
                        }
                    },
                    {
                        label: 'Delete',
                        icon: () => import('@/icons/DeleteOutlined.vue'),
                        handler: (data) => {
                            this.$swal.fire({
                                type: 'warning',
                                title: 'Are you sure?',
                                html: `You are about to delete "<strong>${data[0].name}</strong>".`,
                                showCancelButton: true,
                                confirmButtonColor: '#f56565',
                                confirmButtonText: 'Yes, delete it!',
                                showLoaderOnConfirm: true,
                                preConfirm: (response) => {
                                    return Http.delete(`whmcs/clients/${data[0].id}`);
                                },
                                allowOutsideClick: () => !this.$swal.isLoading()
                            })
                            .then((result) => {
                                if (result.value) {
                                    this.refreshTable = true;
                                    this.$swal.fire({
                                        type: 'success',
                                        title: 'Success!',
                                        text: 'Client was successfully deleted.'
                                    })
                                }
                            });
                        }
                    }
                ],
            }
        },
        methods: {
            store() {
                this.addClientFormIsLoading = true;
                this.addClientForm.errors.clear();
                Http.post('whmcs/clients', this.addClientForm.payload())
                    .then(() => {
                        this.addClientFormIsLoading = false;
                        this.showAddClientModal = false;
                        this.refreshTable = true;
                        this.$swal.fire({
                            type: 'success',
                            title: 'Success',
                            text: 'Client was successfully added.'
                        })
                    })
                    .catch(({ response }) => {
                        this.addClientFormIsLoading = false;
                        this.addClientForm.errors.record(response.data);
                    })
            },
            update() {
                this.editClientFormIsLoading = true;
                this.editClientForm.errors.clear();
                Http.patch(`whmcs/clients/${this.selected.id}`, this.editClientForm.payload())
                    .then(() => {
                        this.editClientFormIsLoading = false;
                        this.showEditClientModal = false;
                        this.refreshTable = true;
                        this.$swal.fire({
                            type: 'success',
                            title: 'Success',
                            text: 'Client was successfully updated.'
                        });
                    })
                    .catch(({ response }) => {
                        this.editClientFormIsLoading = false;
                        this.editClientForm.errors.record(response.data);
                    });
            }
        }
    }
</script>